import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios';
Axios.defaults.baseURL = 'https://apptrade.myfund.com:7103';


// 引入axios
import instance from '../api/index.js';
import apiPath from '../api/path.js';
Vue.prototype.$http = instance;
Vue.prototype.$apiPath = apiPath;

import commonJs from '../js/commonJs.js';

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        // 公司
        fundCompany: [{
            value: '',
            name: '所有基金公司'
        },
        {
            value: '08',
            name: '长盛基金'
        }, {
            value: '25',
            name: '国联安基金'
        },
        {
            value: '18',
            name: '银华基金'
        },
        {
            value: '48',
            name: '工银瑞信基金'
        },
        {
            value: '02',
            name: '国泰基金'
        },
        {
            value: '40',
            name: '东方基金'
        },
        {
            value: '47',
            name: '汇添富基金'
        },
        {
            value: '99',
            name: '上海中登'
        },
        {
            value: '27',
            name: '广发基金'
        },
        {
            value: '05',
            name: '博时基金'
        },
        {
            value: '21',
            name: '金鹰基金'
        },
        {
            value: '59',
            name: '中邮基金'
        },
        {
            value: '98',
            name: '深证中登'
        },
        {
            value: '06',
            name: '鹏华基金'
        },
        {
            value: '10',
            name: '富国基金'
        },
        {
            value: '19',
            name: '万家基金'
        },
        {
            value: '56',
            name: '益民基金'
        },
        {
            value: '57',
            name: '诺德基金'
        },
        {
            value: '26',
            name: '景顺长城基金'
        },
        {
            value: '42',
            name: '天弘基金'
        },
        {
            value: '31',
            name: '申万菱信基金'
        },
        {
            value: '63',
            name: '华商基金'
        },
        {
            value: '17',
            name: '招商基金'
        },
        {
            value: '76',
            name: '国金通用基金'
        },
        {
            value: '36',
            name: '光大保德信基金'
        },
        {
            value: '12',
            name: '国投瑞银基金'
        },
        {
            value: '45',
            name: '国海富兰克林基金'
        },
        {
            value: '41',
            name: '华富基金'
        },
        {
            value: '77',
            name: '德邦基金'
        },
        {
            value: '46',
            name: '华泰柏瑞基金'
        },
        {
            value: '23',
            name: '海富通基金'
        },
        {
            value: '20',
            name: '长城基金'
        },
        {
            value: '64',
            name: '浦银安盛基金'
        },
        {
            value: '39',
            name: '中海基金'
        },
        {
            value: '43',
            name: '新华基金'
        },
        {
            value: '0N',
            name: '国开泰富基金'
        },
        {
            value: '78',
            name: '红塔红土基金'
        },
        {
            value: '0B',
            name: '东海基金'
        },
        {
            value: '07',
            name: '嘉实基金'
        },
        {
            value: '55',
            name: '信诚基金'
        },
        {
            value: '3J',
            name: '北信瑞丰'
        },
        {
            value: '03',
            name: '华夏基金'
        },
        {
            value: '0Z',
            name: '国寿安保基金管理'
        },
        {
            value: '74',
            name: '长安基金'
        },
        {
            value: '44',
            name: '前海开源基金'
        },
        {
            value: '61',
            name: '信达澳银基金'
        },
        {
            value: '72',
            name: '财通基金'
        },
        {
            value: '69',
            name: '民生加银基金'
        },
        {
            value: 'AE',
            name: '第一创业证券股份'
        },
        {
            value: '0F',
            name: '中融基金'
        },
        {
            value: '37',
            name: '上投摩根基金'
        },
        {
            value: '32',
            name: '诺安基金'
        },
        {
            value: '33',
            name: '摩根士丹利基金'
        },
        {
            value: '0L',
            name: '鑫元基金'
        },
        {
            value: '60',
            name: '中欧基金'
        },
        {
            value: '68',
            name: '浙商基金'
        },
        {
            value: '3Z',
            name: '东兴证券'
        },
        {
            value: '4L',
            name: '中科沃土'
        },
        {
            value: '04',
            name: '华安基金'
        },
        {
            value: '11',
            name: '易方达基金'
        },
        {
            value: '15',
            name: '银河基金'
        },
        {
            value: '0A',
            name: '华润元大基金'
        },
        {
            value: '1N',
            name: '中金基金'
        },
        {
            value: '3K',
            name: '山西证券'
        },
        {
            value: '54',
            name: '汇丰晋信基金'
        },
        {
            value: '65',
            name: '英大基金'
        },
        {
            value: '01',
            name: '南方基金'
        },
        {
            value: '22',
            name: '泰达宏利基金'
        },
        {
            value: '16',
            name: '融通基金'
        },
        {
            value: '35',
            name: '天治基金'
        },
        {
            value: '0D',
            name: '中加基金'
        },
        {
            value: '49',
            name: '交银施罗德基金'
        },
        {
            value: '91',
            name: '上海东方证券'
        },
        {
            value: '73',
            name: '方正富邦基金公司'
        },
        {
            value: '1M',
            name: '兴业基金'
        }
        ],
        // 职业
        profession: [
            { id: "1", name: "党政机关负责人及管理人员" },
            { id: "2", name: "企事业单位负责人及管理人员" },
            { id: "3", name: "民主党派和工商联负责人及管理人员" },
            { id: "4", name: "人民团体或群众团体负责人及管理人员" },
            { id: "5", name: "社会组织（社会团体、基金会、社会服务机构、外国商会等）负责人及管理人员" },
            { id: "6", name: "科学研究及教学人员" },
            { id: "7", name: "文学艺术、体育专业人员" },
            { id: "8", name: "新闻出版、文化专业人员" },
            { id: "9", name: "卫生专业技术人员" },
            { id: "10", name: "工程、农业专业人员" },
            { id: "11", name: "法律、会计、审计、税务专业人员" },
            { id: "12", name: "经济和金融专业人员" },
            { id: "13", name: "宗教人士等特殊职业人员" },
            { id: "14", name: "其他专业技术人员" },
            { id: "15", name: "党政机关、企事业单位行政工作人员" },
            { id: "16", name: "民主党派、工商联、人民团体或社会组织等单位工作人员" },
            { id: "17", name: "人民警察、消防、应急救援人员" },
            { id: "18", name: "批发与零售服务人员" },
            { id: "19", name: "房地产服务人员" },
            { id: "20", name: "旅游、住宿和餐饮服务人员" },
            { id: "21", name: "珠宝、黄金等贵金属行业服务人员" },
            { id: "22", name: "文化、体育和娱乐服务人员" },
            { id: "23", name: "典当、拍卖行业服务人员" },
            { id: "24", name: "艺术品或文物收藏行业服务人员" },
            { id: "25", name: "废品、旧货回收服务人员" },
            { id: "26", name: "交通运输、仓储、邮政业服务人员" },
            { id: "27", name: "信息运输、软件和信息技术服务人员" },
            { id: "28", name: "居民、健康服务人员" },
            { id: "29", name: "其他社会生产和社会服务人员" },
            { id: "30", name: "农、林、牧、渔业生产及辅助人员" },
            { id: "31", name: "生产制造及有关人员" },
            { id: "32", name: "军人" },
            { id: "33", name: "国际组织工作人员" },
            { id: "34", name: "离退休人员" },
            { id: "35", name: "个体工商户（含淘宝店自营等）" },
            { id: "36", name: "无业" },
            { id: "37", name: "学生" }
        ],
        //国家数据
        countryList: [{
            "short": "AD",
            "name": "安道尔共和国",
            "en": "Andorra",
            "tel": "376",
            "pinyin": "adeghg"
        },
        {
            "short": "AE",
            "name": "阿拉伯联合酋长国",
            "en": "UnitedArabEmirates",
            "tel": "971",
            "pinyin": "alblhqzg"
        },
        {
            "short": "AF",
            "name": "阿富汗",
            "en": "Afghanistan",
            "tel": "93",
            "pinyin": "afh"
        },
        {
            "short": "AG",
            "name": "安提瓜和巴布达",
            "en": "AntiguaandBarbuda",
            "tel": "1268",
            "pinyin": "atghbbd"
        },
        {
            "short": "AI",
            "name": "安圭拉岛",
            "en": "Anguilla",
            "tel": "1264",
            "pinyin": "agld"
        },
        {
            "short": "AL",
            "name": "阿尔巴尼亚",
            "en": "Albania",
            "tel": "355",
            "pinyin": "aebny"
        },
        {
            "short": "AM",
            "name": "阿美尼亚",
            "en": "Armenia",
            "tel": "374",
            "pinyin": "amny"
        },
        {
            "short": "",
            "name": "阿森松",
            "en": "Ascension",
            "tel": "247",
            "pinyin": "als"

        },
        {
            "short": "AO",
            "name": "安哥拉",
            "en": "Angola",
            "tel": "244",
            "pinyin": "agl"

        },
        {
            "short": "AR",
            "name": "阿根廷",
            "en": "Argentina",
            "tel": "54",
            "pinyin": "agt"

        },
        {
            "short": "AT",
            "name": "奥地利",
            "en": "Austria",
            "tel": "43",
            "pinyin": "adl"

        },
        {
            "short": "AU",
            "name": "澳大利亚",
            "en": "Australia",
            "tel": "61",
            "pinyin": "adly"

        },
        {
            "short": "AZ",
            "name": "阿塞拜疆",
            "en": "Azerbaijan",
            "tel": "994",
            "pinyin": "asbj"

        },
        {
            "short": "BB",
            "name": "巴巴多斯",
            "en": "Barbados",
            "tel": "1246",
            "pinyin": "bbds"

        },
        {
            "short": "BD",
            "name": "孟加拉国",
            "en": "Bangladesh",
            "tel": "880",
            "pinyin": "mjlg"

        },
        {
            "short": "BE",
            "name": "比利时",
            "en": "Belgium",
            "tel": "32",
            "pinyin": "bls"

        },
        {
            "short": "BF",
            "name": "布基纳法索",
            "en": "Burkina-faso",
            "tel": "226",
            "pinyin": "bjnfs"

        },
        {
            "short": "BG",
            "name": "保加利亚",
            "en": "Bulgaria",
            "tel": "359",
            "pinyin": "bjly"

        },
        {
            "short": "BH",
            "name": "巴林",
            "en": "Bahrain",
            "tel": "973",
            "pinyin": "bl"

        },
        {
            "short": "BI",
            "name": "布隆迪",
            "en": "Burundi",
            "tel": "257",
            "pinyin": "bld"

        },
        {
            "short": "BJ",
            "name": "贝宁",
            "en": "Benin",
            "tel": "229",
            "pinyin": "bl"

        },
        {
            "short": "BL",
            "name": "巴勒斯坦",
            "en": "Palestine",
            "tel": "970",
            "pinyin": "blst"

        },
        {
            "short": "BM",
            "name": "百慕大群岛",
            "en": "BermudaIs.",
            "tel": "1441",
            "pinyin": "bmdqd"

        },
        {
            "short": "BN",
            "name": "文莱",
            "en": "Brunei",
            "tel": "673",
            "pinyin": "wl"

        },
        {
            "short": "BO",
            "name": "玻利维亚",
            "en": "Bolivia",
            "tel": "591",
            "pinyin": "blwy"

        },
        {
            "short": "BR",
            "name": "巴西",
            "en": "Brazil",
            "tel": "55",
            "pinyin": "bx"

        },
        {
            "short": "BS",
            "name": "巴哈马",
            "en": "Bahamas",
            "tel": "1242",
            "pinyin": "bhm"

        },
        {
            "short": "BW",
            "name": "博茨瓦纳",
            "en": "Botswana",
            "tel": "267",
            "pinyin": "bcwn"

        },
        {
            "short": "BY",
            "name": "白俄罗斯",
            "en": "Belarus",
            "tel": "375",
            "pinyin": "bels"

        },
        {
            "short": "BZ",
            "name": "伯利兹",
            "en": "Belize",
            "tel": "501",
            "pinyin": "blz"

        },
        {
            "short": "CA",
            "name": "加拿大",
            "en": "Canada",
            "tel": "1",
            "pinyin": "jnd"

        },
        {
            "short": "",
            "name": "开曼群岛",
            "en": "CaymanIs.",
            "tel": "1345",
            "pinyin": "kmqd"

        },
        {
            "short": "CF",
            "name": "中非共和国",
            "en": "CentralAfricanRepublic",
            "tel": "236",
            "pinyin": "zfghg"

        },
        {
            "short": "CG",
            "name": "刚果",
            "en": "Congo",
            "tel": "242",
            "pinyin": "gg"

        },
        {
            "short": "CH",
            "name": "瑞士",
            "en": "Switzerland",
            "tel": "41",
            "pinyin": "rs"

        },
        {
            "short": "CK",
            "name": "库克群岛",
            "en": "CookIs.",
            "tel": "682",
            "pinyin": "kkqd"

        },
        {
            "short": "CL",
            "name": "智利",
            "en": "Chile",
            "tel": "56",
            "pinyin": "zl"

        },
        {
            "short": "CM",
            "name": "喀麦隆",
            "en": "Cameroon",
            "tel": "237",
            "pinyin": "kml"

        },
        {
            "short": "CN",
            "name": "中国",
            "en": "China",
            "tel": "86",
            "pinyin": "zg"

        },
        {
            "short": "CO",
            "name": "哥伦比亚",
            "en": "Colombia",
            "tel": "57",
            "pinyin": "glby"

        },
        {
            "short": "CR",
            "name": "哥斯达黎加",
            "en": "CostaRica",
            "tel": "506",
            "pinyin": "gsdlj"

        },
        {
            "short": "CS",
            "name": "捷克",
            "en": "Czech",
            "tel": "420",
            "pinyin": "jk"

        },
        {
            "short": "CU",
            "name": "古巴",
            "en": "Cuba",
            "tel": "53",
            "pinyin": "gb"

        },
        {
            "short": "CY",
            "name": "塞浦路斯",
            "en": "Cyprus",
            "tel": "357",
            "pinyin": "spls"

        },
        {
            "short": "CZ",
            "name": "捷克",
            "en": "CzechRepublic",
            "tel": "420",
            "pinyin": "jk"

        },
        {
            "short": "DE",
            "name": "德国",
            "en": "Germany",
            "tel": "49",
            "pinyin": "dg"

        },
        {
            "short": "DJ",
            "name": "吉布提",
            "en": "Djibouti",
            "tel": "253",
            "pinyin": "jbt"

        },
        {
            "short": "DK",
            "name": "丹麦",
            "en": "Denmark",
            "tel": "45",
            "pinyin": "dm"

        },
        {
            "short": "DO",
            "name": "多米尼加共和国",
            "en": "DominicaRep.",
            "tel": "1890",
            "pinyin": "dmnjghg"

        },
        {
            "short": "DZ",
            "name": "阿尔及利亚",
            "en": "Algeria",
            "tel": "213",
            "pinyin": "aejly"

        },
        {
            "short": "EC",
            "name": "厄瓜多尔",
            "en": "Ecuador",
            "tel": "593",
            "pinyin": "egde"

        },
        {
            "short": "EE",
            "name": "爱沙尼亚",
            "en": "Estonia",
            "tel": "372",
            "pinyin": "asny"

        },
        {
            "short": "EG",
            "name": "埃及",
            "en": "Egypt",
            "tel": "20",
            "pinyin": "ej"

        },
        {
            "short": "ES",
            "name": "西班牙",
            "en": "Spain",
            "tel": "34",
            "pinyin": "xby"

        },
        {
            "short": "ET",
            "name": "埃塞俄比亚",
            "en": "Ethiopia",
            "tel": "251",
            "pinyin": "aseby"

        },
        {
            "short": "FI",
            "name": "芬兰",
            "en": "Finland",
            "tel": "358",
            "pinyin": "fl"

        },
        {
            "short": "FJ",
            "name": "斐济",
            "en": "Fiji",
            "tel": "679",
            "pinyin": "fj"

        },
        {
            "short": "FR",
            "name": "法国",
            "en": "France",
            "tel": "33",
            "pinyin": "fg"

        },
        {
            "short": "GA",
            "name": "加蓬",
            "en": "Gabon",
            "tel": "241",
            "pinyin": "jp"

        },
        {
            "short": "GB",
            "name": "英国",
            "en": "UnitedKiongdom",
            "tel": "44",
            "pinyin": "yg"

        },
        {
            "short": "GD",
            "name": "格林纳达",
            "en": "Grenada",
            "tel": "1809",
            "pinyin": "glnd"

        },
        {
            "short": "GE",
            "name": "格鲁吉亚",
            "en": "Georgia",
            "tel": "995",
            "pinyin": "gljy"

        },
        {
            "short": "GF",
            "name": "法属圭亚那",
            "en": "FrenchGuiana",
            "tel": "594",
            "pinyin": "fsgyn"

        },
        {
            "short": "GH",
            "name": "加纳",
            "en": "Ghana",
            "tel": "233",
            "pinyin": "jn"

        },
        {
            "short": "GI",
            "name": "直布罗陀",
            "en": "Gibraltar",
            "tel": "350",
            "pinyin": "zblt"

        },
        {
            "short": "GM",
            "name": "冈比亚",
            "en": "Gambia",
            "tel": "220",
            "pinyin": "gby"

        },
        {
            "short": "GN",
            "name": "几内亚",
            "en": "Guinea",
            "tel": "224",
            "pinyin": "jny"

        },
        {
            "short": "GR",
            "name": "希腊",
            "en": "Greece",
            "tel": "30",
            "pinyin": "xl"

        },
        {
            "short": "GT",
            "name": "危地马拉",
            "en": "Guatemala",
            "tel": "502",
            "pinyin": "wdml"

        },
        {
            "short": "GU",
            "name": "关岛",
            "en": "Guam",
            "tel": "1671",
            "pinyin": "gd"

        },
        {
            "short": "GY",
            "name": "圭亚那",
            "en": "Guyana",
            "tel": "592",
            "pinyin": "gyn"

        },
        {
            "short": "HK",
            "name": "香港(中国)",
            "en": "Hongkong",
            "tel": "852",
            "pinyin": "xgzg"

        },
        {
            "short": "HN",
            "name": "洪都拉斯",
            "en": "Honduras",
            "tel": "504",
            "pinyin": "hdls"

        },
        {
            "short": "HT",
            "name": "海地",
            "en": "Haiti",
            "tel": "509",
            "pinyin": "hd"

        },
        {
            "short": "HU",
            "name": "匈牙利",
            "en": "Hungary",
            "tel": "36",
            "pinyin": "xyl"

        },
        {
            "short": "ID",
            "name": "印度尼西亚",
            "en": "Indonesia",
            "tel": "62",
            "pinyin": "ydnxy"

        },
        {
            "short": "IE",
            "name": "爱尔兰",
            "en": "Ireland",
            "tel": "353",
            "pinyin": "ael"

        },
        {
            "short": "IL",
            "name": "以色列",
            "en": "Israel",
            "tel": "972",
            "pinyin": "ysl"

        },
        {
            "short": "IN",
            "name": "印度",
            "en": "India",
            "tel": "91",
            "pinyin": "yd"

        },
        {
            "short": "IQ",
            "name": "伊拉克",
            "en": "Iraq",
            "tel": "964",
            "pinyin": "ylk"

        },
        {
            "short": "IR",
            "name": "伊朗",
            "en": "Iran",
            "tel": "98",
            "pinyin": "yl"

        },
        {
            "short": "IS",
            "name": "冰岛",
            "en": "Iceland",
            "tel": "354",
            "pinyin": "bd"

        },
        {
            "short": "IT",
            "name": "意大利",
            "en": "Italy",
            "tel": "39",
            "pinyin": "ydl"

        },
        {
            "short": "",
            "name": "科特迪瓦",
            "en": "IvoryCoast",
            "tel": "225",
            "pinyin": "ktdw"

        },
        {
            "short": "JM",
            "name": "牙买加",
            "en": "Jamaica",
            "tel": "1876",
            "pinyin": "ymj"

        },
        {
            "short": "JO",
            "name": "约旦",
            "en": "Jordan",
            "tel": "962",
            "pinyin": "yd"

        },
        {
            "short": "JP",
            "name": "日本",
            "en": "Japan",
            "tel": "81",
            "pinyin": "rb"

        },
        {
            "short": "KE",
            "name": "肯尼亚",
            "en": "Kenya",
            "tel": "254",
            "pinyin": "kny"

        },
        {
            "short": "KG",
            "name": "吉尔吉斯坦",
            "en": "Kyrgyzstan",
            "tel": "331",
            "pinyin": "jejst"

        },
        {
            "short": "KH",
            "name": "柬埔寨",
            "en": "Kampuchea(Cambodia)",
            "tel": "855",
            "pinyin": "jpz"

        },
        {
            "short": "KP",
            "name": "朝鲜",
            "en": "NorthKorea",
            "tel": "850",
            "pinyin": "cx"

        },
        {
            "short": "KR",
            "name": "韩国",
            "en": "Korea",
            "tel": "82",
            "pinyin": "hg"


        },
        {
            "short": "KT",
            "name": "科特迪瓦共和国",
            "en": "RepublicofIvoryCoast",
            "tel": "225",
            "pinyin": "ktdwghg"

        },
        {
            "short": "KW",
            "name": "科威特",
            "en": "Kuwait",
            "tel": "965",
            "pinyin": "kwt"

        },
        {
            "short": "KZ",
            "name": "哈萨克斯坦",
            "en": "Kazakstan",
            "tel": "327",
            "pinyin": "hskst"

        },
        {
            "short": "LA",
            "name": "老挝",
            "en": "Laos",
            "tel": "856",
            "pinyin": "lw"

        },
        {
            "short": "LB",
            "name": "黎巴嫩",
            "en": "Lebanon",
            "tel": "961",
            "pinyin": "lbn"

        },
        {
            "short": "LC",
            "name": "圣卢西亚",
            "en": "St.Lucia",
            "tel": "1758",
            "pinyin": "slxy"

        },
        {
            "short": "LI",
            "name": "列支敦士登",
            "en": "Liechtenstein",
            "tel": "423",
            "pinyin": "lzdsd"

        },
        {
            "short": "LK",
            "name": "斯里兰卡",
            "en": "SriLanka",
            "tel": "94",
            "pinyin": "sllk"

        },
        {
            "short": "LR",
            "name": "利比里亚",
            "en": "Liberia",
            "tel": "231",
            "pinyin": "lbly"

        },
        {
            "short": "LS",
            "name": "莱索托",
            "en": "Lesotho",
            "tel": "266",
            "pinyin": "lst"

        },
        {
            "short": "LT",
            "name": "立陶宛",
            "en": "Lithuania",
            "tel": "370",
            "pinyin": "ltw"

        },
        {
            "short": "LU",
            "name": "卢森堡",
            "en": "Luxembourg",
            "tel": "352",
            "pinyin": "lsb"

        },
        {
            "short": "LV",
            "name": "拉脱维亚",
            "en": "Latvia",
            "tel": "371",
            "pinyin": "ltwy"

        },
        {
            "short": "LY",
            "name": "利比亚",
            "en": "Libya",
            "tel": "218",
            "pinyin": "lby"

        },
        {
            "short": "MA",
            "name": "摩洛哥",
            "en": "Morocco",
            "tel": "212",
            "pinyin": "mlg"

        },
        {
            "short": "MC",
            "name": "摩纳哥",
            "en": "Monaco",
            "tel": "377",
            "pinyin": "mng"

        },
        {
            "short": "MD",
            "name": "摩尔多瓦",
            "en": "Moldova,Republicof",
            "tel": "373",
            "pinyin": "medw"

        },
        {
            "short": "MG",
            "name": "马达加斯加",
            "en": "Madagascar",
            "tel": "261",
            "pinyin": "mdjsj"

        },
        {
            "short": "ML",
            "name": "马里",
            "en": "Mali",
            "tel": "223",
            "pinyin": "ml"

        },
        {
            "short": "MM",
            "name": "缅甸",
            "en": "Burma",
            "tel": "95",
            "pinyin": "md"

        },
        {
            "short": "MN",
            "name": "蒙古",
            "en": "Mongolia",
            "tel": "976",
            "pinyin": "mg"

        },
        {
            "short": "MO",
            "name": "澳门（中国）",
            "en": "Macao",
            "tel": "853",
            "pinyin": "am zg"

        },
        {
            "short": "MS",
            "name": "蒙特塞拉特岛",
            "en": "MontserratIs",
            "tel": "1664",
            "pinyin": "mtsstd"

        },
        {
            "short": "MT",
            "name": "马耳他",
            "en": "Malta",
            "tel": "356",
            "pinyin": "met"

        },
        {
            "short": "",
            "name": "马里亚那群岛",
            "en": "MarianaIs",
            "tel": "1670",
            "pinyin": "mlynqd"

        },
        {
            "short": "",
            "name": "马提尼克",
            "en": "Martinique",
            "tel": "596",
            "pinyin": "mtnk"

        },
        {
            "short": "MU",
            "name": "毛里求斯",
            "en": "Mauritius",
            "tel": "230",
            "pinyin": "mlqs"

        },
        {
            "short": "MV",
            "name": "马尔代夫",
            "en": "Maldives",
            "tel": "960",
            "pinyin": "medf"


        },
        {
            "short": "MW",
            "name": "马拉维",
            "en": "Malawi",
            "tel": "265",
            "pinyin": "mlw"

        },
        {
            "short": "MX",
            "name": "墨西哥",
            "en": "Mexico",
            "tel": "52",
            "pinyin": "mxg"

        },
        {
            "short": "MY",
            "name": "马来西亚",
            "en": "Malaysia",
            "tel": "60",
            "pinyin": "mlxy"

        },
        {
            "short": "MZ",
            "name": "莫桑比克",
            "en": "Mozambique",
            "tel": "258",
            "pinyin": "msbk"

        },
        {
            "short": "NA",
            "name": "纳米比亚",
            "en": "Namibia",
            "tel": "264",
            "pinyin": "nmby"

        },
        {
            "short": "NE",
            "name": "尼日尔",
            "en": "Niger",
            "tel": "977",
            "pinyin": "nre"

        },
        {
            "short": "NG",
            "name": "尼日利亚",
            "en": "Nigeria",
            "tel": "234",
            "pinyin": "nrly"

        },
        {
            "short": "NI",
            "name": "尼加拉瓜",
            "en": "Nicaragua",
            "tel": "505",
            "pinyin": "njlg"

        },
        {
            "short": "NL",
            "name": "荷兰",
            "en": "Netherlands",
            "tel": "31",
            "pinyin": "hl"

        },
        {
            "short": "NO",
            "name": "挪威",
            "en": "Norway",
            "tel": "47",
            "pinyin": "nw"

        },
        {
            "short": "NP",
            "name": "尼泊尔",
            "en": "Nepal",
            "tel": "977",
            "pinyin": "nbe"

        },
        {
            "short": "",
            "name": "荷属安的列斯",
            "en": "NetheriandsAntilles",
            "tel": "599",
            "pinyin": "hsadls"

        },
        {
            "short": "NR",
            "name": "瑙鲁",
            "en": "Nauru",
            "tel": "674",
            "pinyin": "nl"

        },
        {
            "short": "NZ",
            "name": "新西兰",
            "en": "NewZealand",
            "tel": "64",
            "pinyin": "xxl"

        },
        {
            "short": "OM",
            "name": "阿曼",
            "en": "Oman",
            "tel": "968",
            "pinyin": "am"

        },
        {
            "short": "PA",
            "name": "巴拿马",
            "en": "Panama",
            "tel": "507",
            "pinyin": "bnm"

        },
        {
            "short": "PE",
            "name": "秘鲁",
            "en": "Peru",
            "tel": "51",
            "pinyin": "bl"

        },
        {
            "short": "PF",
            "name": "法属玻利尼西亚",
            "en": "FrenchPolynesia",
            "tel": "689",
            "pinyin": "fsblnxy"

        },
        {
            "short": "PG",
            "name": "巴布亚新几内亚",
            "en": "PapuaNewCuinea",
            "tel": "675",
            "pinyin": "bbyxjny"

        },
        {
            "short": "PH",
            "name": "菲律宾",
            "en": "Philippines",
            "tel": "63",
            "pinyin": "flb"

        },
        {
            "short": "PK",
            "name": "巴基斯坦",
            "en": "Pakistan",
            "tel": "92",
            "pinyin": "bjst"

        },
        {
            "short": "PL",
            "name": "波兰",
            "en": "Poland",
            "tel": "48",
            "pinyin": "bl"

        },
        {
            "short": "PR",
            "name": "波多黎各",
            "en": "PuertoRico",
            "tel": "1787",
            "pinyin": "bdlg"

        },
        {
            "short": "PT",
            "name": "葡萄牙",
            "en": "Portugal",
            "tel": "351",
            "pinyin": "pty"

        },
        {
            "short": "PY",
            "name": "巴拉圭",
            "en": "Paraguay",
            "tel": "595",
            "pinyin": "blg"

        },
        {
            "short": "QA",
            "name": "卡塔尔",
            "en": "Qatar",
            "tel": "974",
            "pinyin": "kte"

        },
        {
            "short": "",
            "name": "留尼旺",
            "en": "Reunion",
            "tel": "262",
            "pinyin": "lnw"

        },
        {
            "short": "RO",
            "name": "罗马尼亚",
            "en": "Romania",
            "tel": "40",
            "pinyin": "lmny"

        },
        {
            "short": "RU",
            "name": "俄罗斯",
            "en": "Russia",
            "tel": "7",
            "pinyin": "els"

        },
        {
            "short": "SA",
            "name": "沙特阿拉伯",
            "en": "SaudiArabia",
            "tel": "966",
            "pinyin": "stalb"

        },
        {
            "short": "SB",
            "name": "所罗门群岛",
            "en": "SolomonIs",
            "tel": "677",
            "pinyin": "slmqd"

        },
        {
            "short": "SC",
            "name": "塞舌尔",
            "en": "Seychelles",
            "tel": "248",
            "pinyin": "sse"

        },
        {
            "short": "SD",
            "name": "苏丹",
            "en": "Sudan",
            "tel": "249",
            "pinyin": "sd"

        },
        {
            "short": "SE",
            "name": "瑞典",
            "en": "Sweden",
            "tel": "46",
            "pinyin": "rd"

        },
        {
            "short": "SG",
            "name": "新加坡",
            "en": "Singapore",
            "tel": "65",
            "pinyin": "xjp"

        },
        {
            "short": "SI",
            "name": "斯洛文尼亚",
            "en": "Slovenia",
            "tel": "386",
            "pinyin": "slwny"

        },
        {
            "short": "SK",
            "name": "斯洛伐克",
            "en": "Slovakia",
            "tel": "421",
            "pinyin": "slfk"

        },
        {
            "short": "SL",
            "name": "塞拉利昂",
            "en": "SierraLeone",
            "tel": "232",
            "pinyin": "slla"

        },
        {
            "short": "SM",
            "name": "圣马力诺",
            "en": "SanMarino",
            "tel": "378",
            "pinyin": "smln"

        },
        {
            "short": "",
            "name": "东萨摩亚(美)",
            "en": "SamoaEastern",
            "tel": "684",
            "pinyin": "dsmym"

        },
        {
            "short": "",
            "name": "西萨摩亚",
            "en": "SanMarino",
            "tel": "685",
            "pinyin": "xsmy"

        },
        {
            "short": "SN",
            "name": "塞内加尔",
            "en": "Senegal",
            "tel": "221",
            "pinyin": "snje"

        },
        {
            "short": "SO",
            "name": "索马里",
            "en": "Somali",
            "tel": "252",
            "pinyin": "sml"

        },
        {
            "short": "SR",
            "name": "苏里南",
            "en": "Suriname",
            "tel": "597",
            "pinyin": "sln"

        },
        {
            "short": "ST",
            "name": "圣多美和普林西比",
            "en": "SaoTomeandPrincipe",
            "tel": "239",
            "pinyin": "sdmhplxb"

        },
        {
            "short": "SV",
            "name": "萨尔瓦多",
            "en": "EISalvador",
            "tel": "503",
            "pinyin": "sewd"

        },
        {
            "short": "SY",
            "name": "叙利亚",
            "en": "Syria",
            "tel": "963",
            "pinyin": "xly"

        },
        {
            "short": "SZ",
            "name": "斯威士兰",
            "en": "Swaziland",
            "tel": "268",
            "pinyin": "swsl"

        },
        {
            "short": "TD",
            "name": "乍得",
            "en": "Chad",
            "tel": "235",
            "pinyin": "zd"

        },
        {
            "short": "TG",
            "name": "多哥",
            "en": "Togo",
            "tel": "228",
            "pinyin": "dg"

        },
        {
            "short": "TH",
            "name": "泰国",
            "en": "Thailand",
            "tel": "66",
            "pinyin": "tg"

        },
        {
            "short": "TJ",
            "name": "塔吉克斯坦",
            "en": "Tajikstan",
            "tel": "992",
            "pinyin": "tjkst"

        },
        {
            "short": "TM",
            "name": "土库曼斯坦",
            "en": "Turkmenistan",
            "tel": "993",
            "pinyin": "tkmst"

        },
        {
            "short": "TN",
            "name": "突尼斯",
            "en": "Tunisia",
            "tel": "216",
            "pinyin": "tns"

        },
        {
            "short": "TO",
            "name": "汤加",
            "en": "Tonga",
            "tel": "676",
            "pinyin": "tj"

        },
        {
            "short": "TR",
            "name": "土耳其",
            "en": "Turkey",
            "tel": "90",
            "pinyin": "teq"

        },
        {
            "short": "TT",
            "name": "特立尼达和多巴哥",
            "en": "TrinidadandTobago",
            "tel": "1809",
            "pinyin": "tlndhdbg"

        },
        {
            "short": "TW",
            "name": "台湾（中国）",
            "en": "Taiwan",
            "tel": "886",
            "pinyin": "twzg"

        },
        {
            "short": "TZ",
            "name": "坦桑尼亚",
            "en": "Tanzania",
            "tel": "255",
            "pinyin": "tsny"

        },
        {
            "short": "UA",
            "name": "乌克兰",
            "en": "Ukraine",
            "tel": "380",
            "pinyin": "wkl"

        },
        {
            "short": "UG",
            "name": "乌干达",
            "en": "Uganda",
            "tel": "256",
            "pinyin": "wgd"

        },
        {
            "short": "US",
            "name": "美国",
            "en": "UnitedStatesofAmerica",
            "tel": "1",
            "pinyin": "mg"

        },
        {
            "short": "UY",
            "name": "乌拉圭",
            "en": "Uruguay",
            "tel": "598",
            "pinyin": "wlg"

        },
        {
            "short": "UZ",
            "name": "乌兹别克斯坦",
            "en": "Uzbekistan",
            "tel": "233",
            "pinyin": "wzbkst"

        },
        {
            "short": "VC",
            "name": "圣文森特岛",
            "en": "SaintVincent",
            "tel": "1784",
            "pinyin": "swstd"

        },
        {
            "short": "VE",
            "name": "委内瑞拉",
            "en": "Venezuela",
            "tel": "58",
            "pinyin": "wnrl"

        },
        {
            "short": "VN",
            "name": "越南",
            "en": "Vietnam",
            "tel": "84",
            "pinyin": "yn"

        },
        {
            "short": "YE",
            "name": "也门",
            "en": "Yemen",
            "tel": "967",
            "pinyin": "ym"

        },
        {
            "short": "YU",
            "name": "南斯拉夫",
            "en": "Yugoslavia",
            "tel": "381",
            "pinyin": "nslf"

        },
        {
            "short": "ZA",
            "name": "南非",
            "en": "SouthAfrica",
            "tel": "27",
            "pinyin": "nf"

        },
        {
            "short": "ZM",
            "name": "赞比亚",
            "en": "Zambia",
            "tel": "260",
            "pinyin": "zby"

        },
        {
            "short": "ZR",
            "name": "扎伊尔",
            "en": "Zaire",
            "tel": "243",
            "pinyin": "zye"

        },
        {
            "short": "ZW",
            "name": "津巴布韦",
            "en": "Zimbabwe",
            "tel": "263",
            "pinyin": "jbbw"

        }
        ],
        // 银行卡对应图片
        bankImgObj: {
            // 汇付
            '7201': 'back01.png',
            '7202': 'back02.png',
            '7203': 'back04.png',
            '7204': 'back03.png',
            '7205': 'back08.png',
            '7206': 'back10.png',
            '7207': 'back11.png',
            '7208': 'back14.png',
            '7209': 'back15.png',
            '7210': 'back13.png',
            '7211': 'back12.png',
            '7212': 'back06.png',
            '7213': 'back07.png',
            '7214': 'back05.png',
            '7215': 'back16.png',
            '7216': 'back09.png',
            '7217': 'back17.png',
            '7218': 'back18.png',
            // 富友
            '7101': 'back01.png',
            '7102': 'back02.png',
            '7103': 'back03.png',
            '7104': 'back04.png',
            '7105': 'back05.png',
            '7106': 'back06.png',
            '7107': 'back07.png',
            '7108': 'back08.png',
            '7109': 'back09.png',
            '7110': 'back10.png',
            '7111': 'back11.png',
            '7112': 'back12.png',
            '7113': 'back13.png',
        },
        // 银行卡对应图片
        bankImg: {
            '7101': 'logo-7101.png',
            '7102': 'logo-7102.png',
            '7103': 'logo-7103.png',
            '7104': 'logo-7104.png',
            '7105': 'logo-7105.png',
            '7106': 'logo-7106.png',
            '7107': 'logo-7107.png',
            '7108': 'logo-7108.png',
            '7109': 'logo-7109.png',
            '7110': 'logo-7110.png',
            '7111': 'logo-7111.png',
            '7112': 'logo-7112.png',
            '7113': 'logo-7113.png',
            // 汇付
            '7201': 'logo-7201.png',
            '7202': 'logo-7202.png',
            '7203': 'logo-7203.png',
            '7204': 'logo-7204.png',
            '7205': 'logo-7205.png',
            '7206': 'logo-7206.png',
            '7207': 'logo-7207.png',
            '7208': 'logo-7208.png',
            '7209': 'logo-7209.png',
            '7210': 'logo-7210.png',
            '7211': 'logo-7211.png',
            '7212': 'logo-7212.png',
            '7213': 'logo-7213.png',
            '7214': 'logo-7214.png',
            '7215': 'logo-7215.png',
            '7216': 'logo-7216.png',
            '7217': 'logo-7217.png',
            '7218': 'logo-7218.png',
        },
        // 加密
        DESKEY: {
            key1: 'pAssWorD',
            key2: 'Kfit',
            key3: 'DeS'
        },
        // 风险评测方式 0内部系统 1外部系统
        __RISKFLAG: "1",
        // 风险评测方式 内部系统时 即 __RISKFLAG = "0" 前提时  启用内部风险评测与否 0 不启用  1启用
        __INSIDERISKENABLEFLAG: "1",

    },
    mutations: {},
    actions: {
        // 消息推送  type, date, fundname, money, dtDate, fundname2
        pushNews (context, obj) {
            var d = new Date();
            var d2 = d.getMonth() + 1;
            d2 = d2 < 10 ? '0' + d2 : d2;
            var d3 = d.getDate();
            d3 = d3 < 10 ? '0' + d3 : d3;
            var operdate = d2 + '月' + d3 + '日';
            let content = commonJs.getContext(obj.index, operdate, obj.fundname, obj.money, obj.dtDate, obj.fundname2)
            // console.log(content);
            Axios.post('https://apptrade.myfund.com:7103/appnew/user/pushNewsModelContent', {
                custno: commonJs.getCookie('u_custno1'),
                title: '',
                content: content
            }).then(res => {
                if (res.data.code == "200") { }
            }).catch(err => { })
        },
    },
    modules: {}
})